import React from 'react';
import {Squares2X2Icon} from '@heroicons/react/24/outline';

import EditorToolbox from '../../toolboxes/Editor.Toolbox';
import EditorContentContainer from './Editor.Content.Container';

interface IEditorToolboxContainerProps {}

const EditorToolboxContainer = ({}: IEditorToolboxContainerProps) => {
  return (
    <EditorToolbox icon={<Squares2X2Icon />} text="Container" isContainer>
      <EditorContentContainer />
    </EditorToolbox>
  );
};

export default React.memo(EditorToolboxContainer);
